export namespace IntlUtil {
  /**
   * Get the name of a language `lang` according to a given language.
   *
   * This can be used to get either:
   * - an endonym: the language's name according to itself, e.g. "English"
   * - an exonym: the language's name according to some other language, e.g. "Inglés"
   *
   * @example
   * const endonym = IntlUtil.getLanguageName("en"); // "English" according to English
   * const exonym = IntlUtil.getLanguageName("en", "es"); // "Inglés" according to Spanish
   *
   * @param lang The language code to ask the name of
   * @param accordingTo The language we want to name it in (defaults to `lang`)
   *
   * @returns The name of language `lang` according to language `accordingTo`
   */
  export function getLanguageName(lang: string, accordingTo = lang) {
    if (lang === "cimode") {
      return "cimode";
    }
    if (accordingTo === "cimode") {
      return lang;
    }
    try {
      const intl = new Intl.DisplayNames(accordingTo, { type: "language" });
      return intl.of(lang) ?? lang;
    } catch (error) {
      console.error("Failed to get language name:", { lang, error });
      throw error;
    }
  }

  /**
   * Capitalize the first letter of a string.
   *
   * @param text The text to capitalize
   */
  export function sentenceCase(text: string) {
    return text.replace(/^\p{General_Category=Letter}/u, letter => letter.toLocaleUpperCase());
  }
}
